import get from 'lodash/get';
import {useEffect,useState} from 'react';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {
  useGetCurrentProviderQuery,
  useUpdateProviderMutation
} from '../../redux/services/providerApi';
import selectCurrentUser from '../../redux/selectors/selectCurrentUser';
import {useGetHighlightsQuery} from '../../redux/services/providerHighlightApi';
import AppDashboard from '../AppDashboard';
import ProfileSettingsScreen from '../../components/providers/ProfileSettingsScreen';
import LoadingScreen from '../../components/common/LoadingScreen';
import useError from '../../hooks/useError';

const handleSubmit = ({
  props,
  setError,
  provider,
  updateProvider,
  navigate,
}) => async (formData) => {
  const id = get(provider, 'id', null);
  const {error} = await updateProvider({id, body: formData});
  if (error) {
    setError({ message: get(error, 'data.errors', 'Unknown error') });
  } else {
    setTimeout(() => navigate('/providers/settings'), 250);
  }
};

const ProfileSettingsPage = props => {
  const navigate = useNavigate();
  const [updateProvider] = useUpdateProviderMutation();
  const providerQuery = useGetCurrentProviderQuery();
  const providerHighlightQuery = useGetHighlightsQuery({skip: false, refetch: true});
  const errors = useError();
  const setError = err => errors.create(err);
  const provider = get(providerQuery, 'data', null);
  useEffect(() => {
    providerQuery.refetch();
  }, []);
  const childProps = {
    ...props,
    provider,
    setError,
    highlights: get(providerHighlightQuery, 'data', []),
    onSubmit: handleSubmit({props, setError, updateProvider, navigate, provider}),
    // onSubmit: formData => console.log('submitted', formData),
  };
  if (providerQuery.isFetching) return <LoadingScreen />;
  return (
    <AppDashboard
      title='Settings'
      onBack={() => navigate('/providers/settings')}
      loading={providerQuery.isLoading || providerHighlightQuery.isLoading}
    >
      <ProfileSettingsScreen {...childProps} />
    </AppDashboard>
  );
};

const mapState = state => ({
  user: selectCurrentUser()(state),
});

const mapDispatch = () => ({});

export default connect(mapState,mapDispatch)(ProfileSettingsPage);
